/**
 * SOLID Review
 * S — Strong. One use case: read the lobby's roster on entry.
 * O — Strong. The round trip runs it; a change of rule is the Domain's, of sequence the round trip's.
 * L — Strong. Implements its use-case role and the round trip's three strategies exactly.
 * I — Strong. `execute`, and the three strategies the round trip asks for.
 * D — Strong. The decisions and server ports and the round trip, injected.
 */
import type { IContextRequest } from '../ports/IContextRequest';
import type { IPropsClientTableInput } from '../../domain/ports/schemas/ClientTable';
import type { ICommandLobbyRoomLoaded, ICommandNothing, IPayloadRoomRead } from '../../domain/ports/schemas/TableMoves';
import type { TPortOutcome } from '../ports/PortResult';
import type { IUseCase } from '../uml-components/IUseCase';
import type { TServerRoundTrip, TAnswered } from '../shared/ServerRoundTrip';
import type { IConfigDepTable } from './IConfigDepTable';

/** The lobby's roster read on entry (FE1's loadLobbyRoom). */
export class LoadLobbyRoomUseCase implements IUseCase<ICommandNothing, TPortOutcome>, TServerRoundTrip<IPropsClientTableInput, ICommandNothing, IPayloadRoomRead, TAnswered<ICommandLobbyRoomLoaded['roster']>> {
  constructor(private readonly deps: IConfigDepTable) {}

  execute(ctx: IContextRequest, command: ICommandNothing): Promise<TPortOutcome> {
    return this.deps.trip.run(ctx, command, this);
  }

  plan(ctx: IContextRequest, input: IPropsClientTableInput, command: ICommandNothing) {
    return this.deps.decisions.planLobbyRead(ctx, input, command);
  }

  send(ctx: IContextRequest, plan: IPayloadRoomRead) {
    return this.deps.rooms.getRoom(ctx, plan);
  }

  answer(ctx: IContextRequest, input: IPropsClientTableInput, plan: IPayloadRoomRead, answered: TAnswered<ICommandLobbyRoomLoaded['roster']>) {
    const loaded: ICommandLobbyRoomLoaded = { request: plan, roster: answered.value };
    return this.deps.decisions.lobbyRoomLoaded(ctx, input, loaded);
  }
}
